var map = {
	"./admin/admin.module.ngfactory": [
		"G6fN",
		1,
		2,
		4,
		0,
		19
	],
	"./dashboard/dashboard.module.ngfactory": [
		"uP/6",
		0,
		15
	],
	"./login/login.module.ngfactory": [
		"f+ep",
		21
	],
	"./other/other.module.ngfactory": [
		"bp6N",
		1,
		2,
		3,
		4,
		5,
		6,
		8,
		9,
		0,
		32
	],
	"./passlogin/passlogin.module.ngfactory": [
		"UkAL",
		2,
		0,
		20
	],
	"./report/report.module.ngfactory": [
		"ANN+",
		1,
		0,
		18
	],
	"./research/research.module.ngfactory": [
		"HUkd",
		1,
		2,
		3,
		4,
		5,
		6,
		7,
		8,
		9,
		11,
		0,
		31
	],
	"./workload/workload.module.ngfactory": [
		"O4Bf",
		17
	],
	"./workteach/workteach.module.ngfactory": [
		"OPBk",
		16
	],
	"app/workload/chairman/chairman.module.ngfactory": [
		"SJBk",
		1,
		3,
		0,
		26
	],
	"app/workload/dean/dean.module.ngfactory": [
		"yR6H",
		1,
		3,
		0,
		25
	],
	"app/workload/leader/leader.module.ngfactory": [
		"U37Z",
		1,
		2,
		3,
		4,
		0,
		24
	],
	"app/workload/staff/academic-service/academic-service.module.ngfactory": [
		"afCL",
		1,
		2,
		4,
		5,
		6,
		7,
		8,
		9,
		11,
		0,
		28
	],
	"app/workload/staff/research-and-other/research-and-other.module.ngfactory": [
		"HAR5",
		0,
		30
	],
	"app/workload/staff/staff.module.ngfactory": [
		"g0/5",
		1,
		2,
		3,
		4,
		5,
		6,
		7,
		8,
		9,
		0,
		23
	],
	"app/workload/staff/workload-other/teach/teach.module.ngfactory": [
		"aEpW",
		1,
		2,
		3,
		4,
		5,
		6,
		7,
		8,
		0,
		33
	],
	"app/workload/staff/workload-other/workload-other.module.ngfactory": [
		"Rzgc",
		1,
		2,
		3,
		4,
		5,
		6,
		7,
		8,
		9,
		0,
		29
	],
	"app/workload/staff/workteach/intern/intern.module.ngfactory": [
		"+e0W",
		1,
		2,
		3,
		4,
		5,
		6,
		7,
		0,
		35
	],
	"app/workload/staff/workteach/project-and-special-problem/project-and-special-problem.module.ngfactory": [
		"2Vu8",
		1,
		2,
		3,
		4,
		5,
		6,
		7,
		0,
		34
	],
	"app/workload/staff/workteach/seminar/seminar.module.ngfactory": [
		"ENxf",
		1,
		2,
		3,
		4,
		5,
		6,
		7,
		0,
		36
	],
	"app/workload/staff/workteach/workteach.module.ngfactory": [
		"2QUH",
		1,
		2,
		3,
		4,
		5,
		6,
		7,
		8,
		0,
		27
	],
	"app/workload/teacher/research-and-other/research-and-other.module.ngfactory": [
		"8zwY",
		1,
		2,
		3,
		9,
		0,
		38
	],
	"app/workload/teacher/teacher.module.ngfactory": [
		"fYj5",
		1,
		2,
		3,
		5,
		8,
		9,
		0,
		22
	],
	"app/workload/teacher/workload-other/teach/teach.module.ngfactory": [
		"whYZ",
		1,
		2,
		3,
		0,
		40
	],
	"app/workload/teacher/workload-other/workload-other.module.ngfactory": [
		"jZ71",
		1,
		2,
		3,
		9,
		0,
		39
	],
	"app/workload/teacher/workteach/project-and-special-problem/project-and-special-problem.module.ngfactory": [
		"z9g3",
		1,
		2,
		3,
		0,
		41
	],
	"app/workload/teacher/workteach/seminar/seminar.module.ngfactory": [
		"Pcn0",
		1,
		2,
		3,
		0,
		42
	],
	"app/workload/teacher/workteach/workteach.module.ngfactory": [
		"/Zw4",
		1,
		2,
		3,
		4,
		0,
		37
	],
	"app/workteach/leader/leader.module.ngfactory": [
		"45sQ",
		2,
		0,
		43
	],
	"app/workteach/staff/staff.module.ngfactory": [
		"1pCW",
		1,
		2,
		4,
		0,
		45
	],
	"app/workteach/teacher/teacher.module.ngfactory": [
		"H2pG",
		1,
		2,
		4,
		0,
		44
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "crnd";
module.exports = webpackAsyncContext;